/**
 * @param {object} material material object
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showMeasure show material measure in title or not
 * @param {string} overriddenParams.titleIfEmpty title if material is empty
 * @returns {string} formatted title
 */
export const getMaterialTitle = (material, overriddenParams) => {
	if(!material || Object.keys(material).length === 0) return null

	const params = Object.assign({
		showMeasure: true,
		titleIfEmpty: null,
	}, overriddenParams)

	let title = ''
	if (material.name) {
		title += material.name
	}
	if (params.showMeasure && material.measure) {
		title += `, ${material.measure}`
	}

	return title || params.titleIfEmpty
}
